import Backdrop from '@mui/material/Backdrop';
import Popper, { type PopperProps } from '@mui/material/Popper';
import { useTheme } from '@mui/material/styles';

export function DatePickerPopper(props: PopperProps) {
  const { open } = props;
  const { zIndex } = useTheme();

  return (
    <>
      <Popper
        {...props}
        sx={{
          ...props?.sx,
          zIndex: zIndex.modal,
        }}
      />
      <Backdrop open={open} sx={{ opacity: '0 !important' }} />
    </>
  );
}
